import React from 'react';
import { colors, IMFormModal } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { Description } from '@insurancemenu/imenu-components-lib/dist/icons';
import { EditTemplateModalStore } from 'store/modules/upload-documents/ui-stores/editTemplateModalStore';
import { EDIT_TEMPLATE_FORM_ID, EDIT_TEMPLATE_MODAL_TEST_ID } from '../constants';
import AddTemplateSection from '../AddTemplateSection';

interface Props {
  modalStore: EditTemplateModalStore;
}

const EditTemplateModal: React.FC<Props> = observer(({ modalStore }) => {
  const {
    form,
    isVisible,
    documentName,
    shouldResetUploadedFile,
    setFile,

    closeEditModal,
  } = modalStore;

  return isVisible ? (
    <IMFormModal
      show={isVisible}
      onClose={closeEditModal}
      title="Edit Template"
      subtitle={
        <>
          Upload a file or provide a link to add or update <br /> the template for document <b>{documentName}</b>.
        </>
      }
      icon={<Description width="5.6rem" color={colors.green[600]} />}
      formController={form}
      formContent={
        <AddTemplateSection
          isSectionOpenByDefault
          shouldResetUploadedFile={shouldResetUploadedFile}
          formId={EDIT_TEMPLATE_FORM_ID}
          setFile={setFile}
        />
      }
      closeButtonText="Cancel"
      submitButtonText="Save"
      data-test-id={EDIT_TEMPLATE_MODAL_TEST_ID}
      formId={EDIT_TEMPLATE_FORM_ID}
    />
  ) : null;
});

export default EditTemplateModal;
